<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="button-container">
    <button class="custom-button" @click="openEmail()">
      {{buttonText}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'toMail',
  props: {
    buttonText: {
      type: String,
      default: 'Send Email'
    },
  },
  methods:{
    openEmail() {
      if (typeof window.open !== 'undefined') { // 判断浏览器支持
        const url = 'mailto:business@fesagrp.com'; // 邮件地址替换为你需要的
        window.open(url, '_blank'); // 弹出一个新的窗口并尝试打开邮箱应用程序
      } else {
        alert('您的瀏覽器不支持此功能或者沒有默認郵箱客戶端，請使用其他瀏覽器或手動開啟郵件。');
      }
    },
}
}
</script>

<style scoped>
.button-container {
  padding: 0 100px 50px 0;
  /* 使按钮居右，可根据实际布局调整，比如父容器是 flex 布局等场景 */
  display: flex;
  justify-content: flex-end; 
}
.custom-button {
  background-color: #A36F3E; /* 模拟类似的棕色背景，可根据实际需求微调 */
  color: #fff; /* 白色文字 */
  padding: 35px 60px; /* 内边距，调整按钮大小 */
  border: none; /* 去掉默认边框 */
  border-radius: 25px; /* 圆角效果 */
  box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
  cursor: pointer; /* 鼠标悬停显示手型 */
  font-size: 35px; /* 文字大小，可按需调整 */
  font-weight: bolder; /* 加粗字体 */
  position: relative;
  width: 500px;
}
.custom-button::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -2px; /* 控制阴影条与按钮的距离 */
  height: 3px; 
  border-radius: 2px;
  /* 用 box-shadow 模拟阴影效果，也可尝试用 border ，但 border 颜色难做出自然阴影渐变 */
  box-shadow: rgba(0, 0, 0, 0.5) 0px 1px 8px 1px;
  background-color: rgba(0, 0, 0, 0.2);
}

@media screen and (max-width: 1400px) {
  .button-container {
  padding: 0 40px 40px 0;
  /* 使按钮居右，可根据实际布局调整，比如父容器是 flex 布局等场景 */
}
.custom-button {
  padding: 30px 15px; /* 内边距，调整按钮大小 */
  border-radius: 10px; /* 圆角效果 */
  font-size: 25px; /* 文字大小，可按需调整 */
  font-weight: bold; /* 加粗字体 */
  width: 280px;
}
}


@media screen and (max-width: 768px) {
  .button-container {
  padding: 0 10px 20px 0;
  /* 使按钮居右，可根据实际布局调整，比如父容器是 flex 布局等场景 */
}
.custom-button {
  padding: 20px 15px; /* 内边距，调整按钮大小 */
  border-radius: 10px; /* 圆角效果 */
  font-size: 16px; /* 文字大小，可按需调整 */
  font-weight: bold; /* 加粗字体 */
  width: 200px;
}
}
</style>